import { ReactNode } from 'react';

export interface PanelFieldBoxProps {
  label: string;
  isOptional?: boolean;
  isEditing: boolean;
  value: ReactNode;
  editor: ReactNode;
  isEmphasised?: boolean;
  className?: string;
  calculatedNote?: string;
}

export const notSet = <span className='text-gray-400'>Not set</span>;

export function PanelFieldBox({
  label,
  isOptional = false,
  isEditing,
  value,
  editor,
  isEmphasised = false,
  className = '',
  calculatedNote,
}: PanelFieldBoxProps) {
  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white px-3.5 py-2.5 ${className}`}
    >
      <p className='mb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400'>
        {label}
        {isOptional && (
          <span className='ml-1 font-medium text-gray-300'>(optional)</span>
        )}
        {calculatedNote && (
          <span className='ml-1 font-medium normal-case tracking-normal text-gray-400'>
            {calculatedNote}
          </span>
        )}
      </p>
      {isEditing ? (
        editor
      ) : (
        <div
          className={
            isEmphasised
              ? 'text-base font-semibold text-gray-900'
              : 'text-sm text-gray-900'
          }
        >
          {value}
        </div>
      )}
    </div>
  );
}
